import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ResourceService } from '@teem/generic/resource.service';
import { coupons as CouponsApi } from '@teem/constants/api';
import { Coupon, CouponSerializer } from '@teem/models/coupon';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CouponService extends ResourceService<Coupon> {

	constructor(httpClient: HttpClient) {
		super(
			httpClient,
			CouponsApi.endPoint,
			new CouponSerializer()
		)
	}

	public getPromoCodes() {
		return this.httpClient.get(`${CouponsApi.coupons}`)
	}

	createPromoCode(promoData: any): Observable<any> {
		return this.httpClient.post<any>(`${CouponsApi.coupons}`, promoData);
	}

	updatePromoCode(promoData: any): Observable<any> {
		return this.httpClient.put<any>(`${CouponsApi.coupons}/${promoData.uuid}`, promoData);
	}

	editPromoCode(promoData: any): Observable<any> {
		return this.httpClient.get<any>(`${CouponsApi.coupons}/${promoData.uuid}/edit`);
	}

	moveToDraft(promoData: any): Observable<any> {
		return this.httpClient.get<any>(`${CouponsApi.coupons}/${promoData.uuid}/move-to-draft`);
	}

	activatePromo(promoData: any): Observable<any> {
		return this.httpClient.get<any>(`${CouponsApi.coupons}/${promoData.uuid}/activate`);
	}
	
	delete(promoData: any): Observable<any> {
		return this.httpClient.delete<any>(`${CouponsApi.coupons}/${promoData.uuid}/delete`);
	}
}
